<template>
<span>
  <van-field
    readonly
    clickable
    :required="required"
    :rules="rules"
    :label="label"
    :placeholder="placeholder"
    :right-icon="rightIcon ? 'arrow' : ''"
    :value="value"
    :disabled="disabled"
    @click="handleClick"
  />
  <van-popup v-model="showPicker" position="bottom">
    <van-datetime-picker
      :type="type"
      v-model="pickerTime"
      :min-date="minDate"
      :max-date="maxDate"
      :formatter="formatter"
      @confirm="confirmTime"
      @cancel="showPicker = false"
    />
  </van-popup> 
</span>
</template>

<script>
import { getymd, dateFormat } from '@/utils'
export default {
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'datetime'
    },
    placeholder: {
      type: String,
      default: '',
    },
    rightIcon: {
      type: Boolean,
      default: true,
    },
    minDate: {
      type: Date,
    },
    maxDate: {
      type: Date,
    },
    required: {
      type: Boolean,
      default: false,
    },    
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
  },
  model: {
    event: 'input'
  },
  data() {
    const defaultTime = new Date(this.value)
    return {
      showPicker: false, 
      //设置打开的默认值为当前时间
      pickerTime: defaultTime,
    }
  },
  methods: {
    handleClick() {
      if(this.disabled) return
      this.showPicker = true
    },
    // 确定选择时间
    confirmTime (date) { 
      const val = this.type === 'date' ? dateFormat(date, 'yyyy-MM-dd') : getymd(date)
      this.$emit('input', val)
      this.showPicker = false
    },
    // 时间自定义格式
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      if (type === 'hour') {
        return val + '时';
      }
      if (type === 'minute') {
        return val + '分';
      }
      if (type === 'second') {
        return val + '秒';
      }
      return val;
    },
  },
}
</script>